export const addReturnTypeFields = [
  {
    key: "acceptType",
    name: "Accept Type",
    type: "select",
    required: true,
    placeholder: "Select content type",
    options: [
      { label: "Form URL Encoded", value: "APPLICATION_FORM_URLENCODED" },
      { label: "JSON (UTF-8)", value: "APPLICATION_JSON_UTF8" },
      { label: "Binary Stream", value: "APPLICATION_OCTET_STREAM" },
      { label: "XML", value: "APPLICATION_XML" },
      { label: "Multipart Form Data", value: "MULTIPART_FORM_DATA" },
      { label: "HTML", value: "TEXT_HTML" },
      { label: "Text-based XML", value: "TEXT_XML" },
    ],
  },
  {
    key: "returnType",
    name: "Data Type",
    type: "select",
    required: true,
    placeholder: "Select data type",
    options: [
      {
        label: "String",
        value: "String",
      },
      {
        label: "Integer",
        value: "Integer",
      },
      {
        label: "Boolean",
        value: "Boolean",
      },
      {
        label: "List",
        value: "List",
      },
      {
        label: "Schema",
        value: "Schema",
      },
      {
        label: "Map",
        value: "Map",
      },
    ],
  },
  {
    key: "complexReturnType",
    name: "Component Type",
    type: "select",
    required: true,
    placeholder: "Select component type",
    options: [
      {
        label: "String",
        value: "String",
      },
      {
        label: "Integer",
        value: "Integer",
      },
      {
        label: "Boolean",
        value: "Boolean",
      },
      {
        label: "Schema",
        value: "Schema",
      }
    ],
    visibleIf: { key: "returnType", value: "List" },
    value: 'String',
  },
  {
    key: "complexReturnTypeMap",
    name: "Component Type",
    type: "select",
    required: true,
    placeholder: "Select component type",
    options: [
      {
        label: "String",
        value: "String",
      },
      {
        label: "Integer",
        value: "Integer",
      },
      {
        label: "Boolean",
        value: "Boolean",
      },
    ],
    visibleIf: { key: "returnType", value: "Map" },
    value: 'String',
  },
  {
    key: "schemaId",
    name: "Schema Name",
    type: "select",
    required: true,
    isLoading:false,
    placeholder: "Select schema name",
    options: [],
    visibleIf: { key: "returnType", value: "Schema" },
  },
  {
    key: "schemaIdCom",
    name: "Schema Name",
    type: "select",
    required: true,
    isLoading:false,
    placeholder: "Select schema name",
    options: [],
    visibleIf: { key: "complexReturnType", value: "Schema" },
  },
];

export const addParameterFields = [
  {
    key: "name",
    name: "Parameter Name",
    type: "text-input",
    required: true,
    placeholder: "Enter parameter name",
  },
  {
    key: "type",
    name: "Parameter Type",
    type: "select",
    required: true,
    placeholder: "Select parameter type",
    options: [
      {
        label: "Query",
        value: "QUERY",
      },
      {
        label: "Path Variable",
        value: "PATH_VARIABLE",
      },
    ],
  },
];

export const addHeaderFields = [
  {
    key: "key",
    name: "Key",
    type: "text-input",
    required: true,
    placeholder: "Enter key",
  },
  {
    key: "value",
    name: "Value",
    type: "text-input",
    required: true,
    placeholder: "Enter value",
  },
];

export const createServiceFields = [
  {
    key: "name",
    name: "API Service Name",
    type: "text-input",
    required: true,
    customClass: "w-50",
    placeholder: "Enter API Service Name",
  },
  {
    key: "url",
    name: "Service/Base URL",
    placeholder: "Add service/base URL",
    type: "text-input",
    required: true,
  },
];

export const createServiceFieldsEdit = [
  {
    key: "name",
    name: "API Service Name",
    type: "text-input",
    required: true,
    isDisabled: true,
    customClass: "w-50",
    placeholder: "Enter API Service Name",
  },
  {
    key: "url",
    name: "Service/Base URL",
    placeholder: "Add service/base URL",
    type: "text-input",
    required: true,
  },
];
